import { StyleSheet, Dimensions } from 'react-native';

import { pt, px } from '../../../common/utils';

const winWidth = Dimensions.get('window').width;
const winHeight = Dimensions.get('window').height;

const st = StyleSheet.create({
    container: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1000,
        elevation: 2000,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    modalContainer: {
        position: 'absolute',
        zIndex: 101,
        // FIXED: 华为p10plus不居中
        width: winWidth,
        height: winHeight,
        alignItems: 'center',
        top: winHeight / 4.5
        // justifyContent: 'center'
    },
    mask: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 102
    },
    innerContainer: {
        position: 'absolute',
        zIndex: 9999999,
        width: pt(291),
        maxHeight: pt(500),
        backgroundColor: '#fff',
        borderTopLeftRadius: pt(12),
        borderTopRightRadius: pt(12),
        borderBottomLeftRadius: pt(12),
        borderBottomRightRadius: pt(12)
    },
    dialogInner: {
        justifyContent: 'space-between'
    },
    content_color: {
        color: '#262626'
    },
    title: {
        fontSize: pt(16),
        fontWeight: 'bold',
        paddingBottom: pt(7.5)
    },
    main: {
        paddingLeft: pt(24),
        paddingRight: pt(24),
        // paddingBottom: pt(14),
        // textAlign: 'center',
        fontSize: pt(12),
        lineHeight: pt(17),
        color: '#8C8C8C'
    },
    content_view: {
        flexDirection: 'column',
        alignItems: 'center'
    },
    content: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: pt(27),
        paddingHorizontal: pt(4)
    },
    actionGroup: {
        flexDirection: 'row',
        paddingHorizontal: pt(14),
        paddingBottom: pt(12),
        marginTop: pt(14)
        // borderTopWidth: px(2),
        // borderTopColor: 'rgba(0, 0, 0, 0.1)'
    },
    flex: {
        flex: 1
    },
    btn: {
        justifyContent: 'center',
        alignItems: 'center',
        height: 50
    },
    cancelBtn: {
        backgroundColor: 'transparent'
    },
    cancelText: {
        color: '#898989',
        fontSize: pt(17)
    },
    confirmBtn: {
        backgroundColor: 'transparent'
        // borderLeftWidth: px(2),
        // borderLeftColor: 'rgba(0, 0, 0, 0.1)'
    },
    confirmText: {
        color: '#2B84FF',
        fontSize: pt(17)
    },
    view_btn: {
        width: pt(145),
        height: pt(31),
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: pt(1),
        borderColor: '#ccc',
        borderRadius: pt(12),
        marginLeft: pt(0),
        overflow: 'hidden'
    },
    view_btnds: {
        width: pt(112),
        height: pt(31),
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: pt(1),
        borderColor: '#ccc',
        borderRadius: pt(17),
        overflow: 'hidden'
    },
    view_btnds_left: {
        width: pt(112),
        height: pt(31),
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: px(2),
        borderColor: '#F2270C',
        borderRadius: pt(17),
        overflow: 'hidden'
    },
    text_white: {
        color: '#fff',
        fontSize: pt(12)
    },
    text_red: {
        color: '#F2270C',
        fontSize: pt(12)
    },
    tel_input: {

        height: pt(41),
        // marginVertical: pt(9),
        padding: 0,
        paddingLeft: pt(10),
        // borderWidth: 0,
        borderRadius: pt(4),
        backgroundColor: '#F2F3F3',
        fontSize: pt(12),
        color: '#252525',
        marginTop: pt(14)
    },
    bottom_bx: {
        // flexDirection: 'row',
        // height: pt(65),
        // borderBottomColor: '#F2F2F2',
        // borderBottomWidth: pt(1),
        marginHorizontal: pt(24)
        // marginBottom:pt()
    },
    clear_input: {
        position: 'absolute',
        right: pt(3),
        top: pt(19),
        padding: pt(10)
    },
    clear_input_img: {
        height: pt(14),
        width: pt(14)
    },
    red_tip: {
        marginHorizontal: pt(24),
        marginTop: pt(10)
    },
    red_txt: {
        fontSize: pt(12),
        color: '#F2270C'
    }
});

module.exports = st;
